import Card from "@mui/material/Card";
import SoftBox from "../../../components/SoftBox";
import {useNavigate, useParams} from "react-router-dom";
import {getCompanyAdminById} from "../../../api/companyadmin/companyAdminApiClient";
import React, {useEffect, useState} from "react";
import {Alert, Button, CardContent, Chip, CircularProgress, Grid, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import CompanyAdminInfo from "./CompanyAdminInfo";
import {useRayzayUIController} from "../../../context";

function CompanyAdminDetailPage() {
    const theme = useTheme();
    const navigate = useNavigate();
    const {companyAdminId} = useParams();
    const [companyAdmin, setCompanyAdmin] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [controller] = useRayzayUIController();
    const {loggedInUserDetail} = controller;

    const loadCompanyAdminDetails = async () => {
        setLoading(true);
        setError(null);
        console.log('Loading company admin details for ID:', companyAdminId);

        try {
            const res = await getCompanyAdminById(companyAdminId);
            console.log('Company Admin API response:', res);
            const companyAdminData = res.data;
            setCompanyAdmin(companyAdminData);
        } catch (error) {
            console.error("Failed to load company admin details:", error);
            if (error.response?.status === 403) {
                setError("Access denied. You don't have permission to view company admin details.");
            } else if (error.response?.status === 401) {
                setError("Authentication required. Please log in again.");
            } else if (error.response?.status === 404) {
                setError("Company admin not found.");
            } else {
                setError("Failed to load company admin details. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (companyAdminId) {
            loadCompanyAdminDetails();
        }
    }, [companyAdminId]);

    if (loading) {
        return (
            <SoftBox display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress/>
            </SoftBox>
        );
    }

    if (error) {
        return (
            <SoftBox p={3}>
                <Alert severity="error">{error}</Alert>
                {error.includes("Access denied") && (
                    <SoftBox mt={2}>
                        <Typography variant="body2" color="text.secondary" mb={2}>
                            Current user role: {loggedInUserDetail?.userRole || 'Not logged in'}
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => navigate('/authentication/sign-in')}
                        >
                            Sign In
                        </Button>
                    </SoftBox>
                )}
            </SoftBox>
        );
    }

    return (
        <SoftBox>
            <SoftBox mb={3}>
                <Typography variant="h4" gutterBottom>
                    Company Admin Details
                </Typography>
            </SoftBox>

            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <SoftBox display="flex" flexDirection="column" alignItems="center" p={2}>
                                <SoftBox
                                    component="img"
                                    src={companyAdmin.profilePic ? `data:image/png;base64,${companyAdmin.profilePic}` : undefined}
                                    alt="Company Admin Profile"
                                    sx={{
                                        width: 150,
                                        height: 150,
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: `3px solid ${theme.palette.grey[300]}`,
                                        mb: 2
                                    }}
                                />
                                <Typography variant="h5" gutterBottom>
                                    {companyAdmin.firstName} {companyAdmin.lastName}
                                </Typography>
                                <Chip
                                    label={companyAdmin.userRole || 'COMPANY_ADMIN'}
                                    color="primary"
                                    variant="outlined"
                                    sx={{mb: 1}}
                                />
                                <Chip
                                    label={companyAdmin.status || 'ACTIVE'}
                                    color={companyAdmin.status === 'ACTIVE' ? 'success' : 'error'}
                                    variant="outlined"
                                />
                            </SoftBox>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={8}>
                    <CompanyAdminInfo companyAdmin={companyAdmin}/>
                </Grid>
            </Grid>
        </SoftBox>
    );
}

export default CompanyAdminDetailPage;

